module.exports = __webpack_public_path__ + "img/logo-blanco - cortado.daedc5b8.png";